<div class="container">
  <h1>Thanks! You are subscribed.</h1>

  <p role="alert" aria-atomic="true">You are subscribed to {{ projectInfo?.ProjectName }}.</p>

  <p>Please check your email if you would like to edit your subscription preferences.</p>

  <div class="checkmark-container">
    <mat-icon class="checkmark">check_circle</mat-icon>
  </div>

  <div class="button-container">
    <button class="blue-outline-button" (click)="startOver()">Back to Search</button>
  </div>
</div>
